export const validateCatch = function (effortData) {
  let errors = [];
  if (effortData.species === "") {
    errors[errors.length] = "No Species provided";
  }
  let checkKept = true;
  let checkDiscarded = true;
  if (effortData.species === "NC") {
    checkKept = false;
    checkDiscarded = false;
  }
  if (checkKept && (effortData.kept === "" || effortData.kept === null)) {
    errors[errors.length] = "No Kept provided";
  }
  if (checkKept && effortData.kept !== "") {
    if (isNaN(effortData.kept)) {
      errors[errors.length] = "No numeric value for Kept provided";
    } else {
      if (Number(effortData.kept) < 0) {
        errors[errors.length] = "Kept must be 0 or larger";
      }
    }
  }
  if (
    checkDiscarded &&
    (effortData.discarded === "" || effortData.discarded === null)
  ) {
    errors[errors.length] = "No Discarded provided";
  }
  if (checkDiscarded && effortData.discarded !== "") {
    if (isNaN(effortData.discarded)) {
      errors[errors.length] = "No numeric value for Discarded provided";
    } else {
      if (Number(effortData.discarded) < 0) {
        errors[errors.length] = "Discarded must be 0 or larger";
      } else if (
        Number(effortData.kept) === 0 &&
        Number(effortData.discarded) <= 0
      ) {
        errors[errors.length] = "Discarded must be greater than 0";
      }
    }
  }
  if (checkKept && effortData.uom === "") {
    errors[errors.length] = "Unknown Unit of Measurement";
  }
  return errors;
};
